module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store.2928664f.svg";